"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mockMenuTypes = void 0;
var mockMenuTypes = [{
  itemType: 'LTO',
  typeDescription: 'Limited Time Offer'
}, {
  itemType: 'LRP',
  typeDescription: 'Large Round Pizzas'
}, {
  itemType: 'DDD',
  typeDescription: 'Detroit-Style Deep Dish Pizzas'
}, {
  itemType: 'HNRS',
  typeDescription: 'Sides'
}, {
  itemType: 'CNR',
  typeDescription: 'Drinks'
}];
exports.mockMenuTypes = mockMenuTypes;